import { all, call, put, putResolve, select, takeLatest, } from 'typed-redux-saga/macro';
import { getBankConnections, getFeatureFlags, getGroups, getSmartRules, getSpaceInvites, getUser, } from 'actions';
import { getFxFees, getPendingTopups, getRequiredNationalIdentifiers, getSecclAUMFees, updateWealthAccounts, } from 'actions/invest';
import { REFRESH_ON_START } from 'actions/types';
import { selectHasCountryOfTaxResidence, selectIsAnyTradingAccountActive, } from 'features/invest/reducers/selectors';
import { getActiveReferralProgram } from 'features/inviteFriend/actions';
import { getPots, getPotsInformation, getSavingsPlan, } from 'features/pots/actions';
import { selectIsPotsAccountActive } from 'features/pots/reducers/selectors';
import { getCreditAndDebt } from 'features/pay/actions/payments';
import { selectIsGBUser } from 'reducers/selectors';
import { setupDashboardStackWorker } from './RefreshSaga';
function* fetchAppData() {
    log('[onAppActiveSaga] refreshing data...', false, 'cyan');
    yield* all([
        putResolve(getUser()),
        putResolve(getBankConnections()),
        putResolve(getActiveReferralProgram()),
        putResolve(getFeatureFlags()),
        putResolve(getSpaceInvites('PENDING')),
    ]);
    yield* call(setupDashboardStackWorker);
    yield* put(getSmartRules());
    yield* put(getGroups());
    yield* put(getCreditAndDebt());
    const isGBUser = yield* select(selectIsGBUser);
    if (isGBUser) {
        yield* put(getFxFees());
        yield* put(getSecclAUMFees());
        yield* put(getSavingsPlan()); // TODO replace with get saving plan fees
        const countryOfTaxResidence = yield* select(selectHasCountryOfTaxResidence);
        if (countryOfTaxResidence) {
            yield* put(getRequiredNationalIdentifiers());
        }
        const isAnyTradingAccountActive = yield* select(selectIsAnyTradingAccountActive);
        const isPotsAccActive = yield* select(selectIsPotsAccountActive);
        if (isPotsAccActive) {
            yield* put(getPots());
        }
        if (isAnyTradingAccountActive || isPotsAccActive) {
            yield* put(getPendingTopups());
            yield* put(updateWealthAccounts());
        }
        yield* put(getPotsInformation());
    }
}
function* onAppActiveSaga() {
    yield* takeLatest(REFRESH_ON_START, fetchAppData);
}
export default onAppActiveSaga;
